const mapaDeTildes: Record<string, string> = {
    á: 'a',
    à: 'a',
    ä: 'a',
    â: 'a',
    é: 'e',
    è: 'e',
    ë: 'e',
    ê: 'e',
    í: 'i',
    ì: 'i',
    ï: 'i',
    î: 'i',
    ó: 'o',
    ò: 'o',
    ö: 'o',
    ô: 'o',
    ú: 'u',
    ù: 'u',
    ü: 'u',
    û: 'u',
    Á: 'A',
    À: 'A',
    Ä: 'A',
    Â: 'A',
    É: 'E',
    È: 'E',
    Ë: 'E',
    Ê: 'E',
    Í: 'I',
    Ì: 'I',
    Ï: 'I',
    Î: 'I',
    Ó: 'O',
    Ò: 'O',
    Ö: 'O',
    Ô: 'O',
    Ú: 'U',
    Ù: 'U',
    Ü: 'U',
    Û: 'U',
};

/**
 * Quita los espacios en blanco de ambos extremos de la cadena y colapsa los espacios
 * intermedios de modo que solo haya uno entre cada palabra.
 */
export function colapsarEspacios(texto: string) {
    return texto.trim().replace(/\s\s+/g, ' ');
}

/**
 * Retorna la cadena entregada con las vocales tildadas reemplazadas por sus equivalentes sin tilde.
 */
export function sanearTildes(nombre: string) {
    return nombre.replace(/[áàäéèëíìïóòöúùüâêîôû]/gi, c => mapaDeTildes[c] || c);
}

/**
 * Retorna `true` si _subcadena_ es efectivamente una subcadena de _cadena_ o `false`
 * en caso contrario. Es decir, verifica si el segundo argumento contiene al primero.
 */
export function textoEstaContenidoEn(subcadena: string, cadena: string): boolean {
    return cadena.indexOf(subcadena) !== -1;
}

/**
 * Retorna `true` si las palabras de la primera cadena contienen (como subcadenas) a
 * las palabras de la segunda cadena, o retorna `false` en caso contrario. Es decir,
 * determina si cada una de las palabras de la segunda cadena es subcadena de al menos
 * una de las palabras de la primera cadena, en algún orden.
 *
 * Cada palabra se determina separando la cadena en 1 o más espacios en blanco consecutivos.
 */
export function buscarPalabras(texto1: string, texto2: string) {
    const separado1 = texto1.split(/\s+/);
    const separado2 = texto2.split(/\s+/);
    return separado2.every(x => separado1.some(y => textoEstaContenidoEn(x, y)));
}



// WEBPACK FOOTER //
// ./src/utilidades/texto.ts